import React, { useEffect, useRef } from 'react';
import { Box } from '@chakra-ui/react';
import mermaid from 'mermaid';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

mermaid.initialize({
  startOnLoad: true,
  theme: 'default',
  flowchart: {
    useMaxWidth: false,
    curve: 'basis',
  },
});

const InteractiveMermaid = ({ mermaidCode }) => {
  const mermaidRef = useRef(null);

  useEffect(() => {
    if (mermaidRef.current && mermaidCode) {
      mermaid.render('mermaid-chart', mermaidCode).then(({ svg, bindings }) => {
        mermaidRef.current.innerHTML = svg;
        const svgElement = mermaidRef.current.querySelector('svg');
        if (svgElement) {
          // Remove fixed dimensions and set dynamic sizing
          svgElement.removeAttribute('width');
          svgElement.removeAttribute('height');
          svgElement.style.width = '100%';
          svgElement.style.height = '100%';
          svgElement.style.maxWidth = 'none';
          svgElement.style.maxHeight = 'none';

          // Adjust viewBox to fit content dynamically
          const bbox = svgElement.getBBox();
          if (bbox.width && bbox.height) {
            svgElement.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
          }
        }
      }).catch((err) => {
        console.error('Mermaid rendering error:', err);
      });
    }
  }, [mermaidCode]);

  return (
    <TransformWrapper
      initialScale={0.8} // Start with a slightly zoomed-out view to fit content
      minScale={0.1} // Allow deeper zoom out
      maxScale={10} // Increase max zoom for clarity
      wheel={{ step: 0.2 }} // Smoother zoom steps
      centerOnInit={true}
      centerZoomedOut={true}
      limitToBounds={false} // Allow panning beyond for now
      alignmentAnimation={{ sizeX: true, sizeY: true }}
      style={{ width: '100%', height: '100%' }}
    >
      <TransformComponent
        wrapperStyle={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'visible', // Prevent clipping
        }}
      >
        <Box
          ref={mermaidRef}
          width="100%"
          height="100%"
          borderWidth={1}
          borderRadius="md"
          p={2}
          bg="white"
          boxShadow="md"
        />
      </TransformComponent>
    </TransformWrapper>
  );
};

export default InteractiveMermaid;